import PropTypes from 'prop-types';
import { IconButton, Stack, Tooltip } from '@mui/material';

import { componentsSize } from 'constants/components';

const styles = {
  iconButton: ({ palette }) => ({
    padding: 1,
    svg: {
      color: palette.text.primary,
      width: 35,
      height: 35,
    },
  }),
  iconButtonSmall: {
    svg: {
      width: 24,
      height: 24,
    },
  },
};

export const IconsActions = ({ actions = [], size = componentsSize.large }) => (
  <Stack spacing={2} direction="row" alignItems="center" justifyContent="flex-end" display="inline-flex">
    {actions.map(
      ({ icon, label, onClick, hideOption }) =>
        !hideOption && (
          <Tooltip arrow key={label} title={label}>
            <IconButton
              onClick={onClick}
              sx={[styles.iconButton, size === componentsSize.small && styles.iconButtonSmall]}
            >
              {icon}
            </IconButton>
          </Tooltip>
        ),
    )}
  </Stack>
);

IconsActions.propTypes = {
  size: PropTypes.oneOf(Object.values(componentsSize)),
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      icon: PropTypes.node,
      onClick: PropTypes.func,
      hideOption: PropTypes.bool,
    }),
  ),
};
